import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    Button,
} from '@mui/material';

import ProjectContext from '../../contexts/ProjectContext';

import ExpandedTextField from '../display/ExpandedTextField';
import {useFetch} from '../../components/auth/useFetch';

export default function CreateSourcePopover(props){

    const {
        closeMenu,
        setSources,
        setSourceProcessingConfig,
        sources,
        setCurrentSource,
    } = props

    const projectContext = useContext(ProjectContext);

    const [sourceName, setSourceName] = useState('')
    const fetchWithAuth = useFetch()

    // const [templateName, setTemplateName] = useState('')

    const createSource = () => {
        // Create a basic working CSV export by default - this should guarantee Konsol features work out of the box
        //   user can customise after source creation
        const body = {
            source: sourceName,
            shortname: `${sourceName[0]}${sourceName[Math.trunc(sourceName.length / 2)]}${sourceName[sourceName.length - 1]}`.toUpperCase(),
            struct: "tabular",
            type: "metadata",
            link: [{search: {[sourceName]: {"$exists": false}}}],
            preprocess: {
                column_index: 0,
                data_index: 1,
                delimiter: "comma",
                encoding: "utf8",
                extension: "csv"
              },
        }
        let url = `${process.env.REACT_APP_BACKEND_URL}/konsol/sources/`
        fetchWithAuth(url, {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
                'X-Project-ID': projectContext?.project_db,
            },
            body: JSON.stringify(body),
        })
        .catch(e => {
            console.error(e);
        })
        .then(() => {
            // if(templateName){
            //     submitConfig({
            //         'deliverable_name': exportName,
            //         'deliverable_type': exportType
            //     }, templateName)
            // }
            // else{
            setSources((prev) => {
                return [...prev, sourceName]
            })
            setSourceProcessingConfig(body)
            // }
            setCurrentSource(sourceName)
            closeMenu()
        })
    }

    const createButtonIsDisabled = () => {
        if(sourceName){
            // // Check if template is selected
            // if(templateName){
            //     return false
            // }
            if(sources.includes(sourceName))
            {
                return true
            }
            return false
        }
        return true
    }

    return (
        <Box
            width={'260px'}
        >
            <Box
                height={'80px'}
                overflow={'auto'}
            >
                <ExpandedTextField
                    label={'Source Name'}
                    value={sourceName}
                    onChange={(e) => setSourceName(e.target.value)}
                />
            </Box>     
            <Box
                display={'flex'}
                justifyContent={'space-between'}
            >
                <Button
                    sx={{ color: 'red' }}
                >
                    Cancel
                </Button>
                <Button
                    sx={{ color: 'white' }}
                    onClick={createSource}
                    disabled={createButtonIsDisabled()}
                >
                    Create
                </Button>
            </Box>
        </Box>
    )
}